import './HealthPanel.scss';

export { default as HealthPanel } from './HealthPanel';
export { default as healthPanelSchema } from './healthPanelSchema';
